import { FileAddOutlined } from "@ant-design/icons";
import { RouteComponentProps, useNavigate, Link } from "@reach/router";
import { Button, Card, Col, Row, Typography, notification } from "antd";
import Modal from "antd/lib/modal/Modal";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import Ratio from "react-ratio";

import { MultiversAdministration } from "../component/multivers";
import { useStore, Administration } from "../store";

const styles = {
  administration: {
    paddingRight: 20,
    paddingBottom: 20,
  },
};

interface Props extends RouteComponentProps {}
const Select: FunctionComponent<Props> = (props) => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const { multivers } = useStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const showForm = () => setIsFormVisible(true);
  const hideForm = () => setIsFormVisible(false);

  const addAdministration = async (data: any) => {
    try {
      await multivers.addAdministration(data);
      navigate(data.code);
    } catch (error) {
      notification.error({
        message: t("Add administration failed"),
        description: (error as Error)?.message,
      });
    }
  };

  const renderAdministration = (administration: Administration) => {
    const { description } = administration;
    return (
      <Col
        xs={12}
        sm={12}
        md={8}
        lg={6}
        xl={5}
        xxl={4}
        key={administration.id}
        style={styles.administration}
      >
        <Link to={`${administration.id}/order`}>
          <Card>
            <Ratio ratio={2}>
              <Typography.Title level={3}>{description}</Typography.Title>
              <Typography.Text>{administration.id}</Typography.Text>
            </Ratio>
          </Card>
        </Link>
      </Col>
    );
  };
  const administrations = multivers.administrations.docs.slice();
  return (
    <>
      <Row>
        <Col flex="auto">
          <Typography.Title>{t("Administration")}</Typography.Title>
        </Col>
        <Col flex="none">
          <Button
            type="primary"
            icon={<FileAddOutlined />}
            style={{ alignSelf: "center" }}
            onClick={showForm}
          >
            {t("Add administration")}
          </Button>
        </Col>
      </Row>
      <Row>
        {administrations.length ? (
          administrations.map(renderAdministration)
        ) : (
          <Typography.Text disabled>
            <Trans>No administrations found</Trans>
          </Typography.Text>
        )}
      </Row>
      <Modal
        title={t("Add administration")}
        visible={isFormVisible}
        footer={null}
        onCancel={hideForm}
      >
        <MultiversAdministration
          onCancel={hideForm}
          onSubmit={addAdministration}
        />
      </Modal>
    </>
  );
};

export default observer(Select);
